import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Mail, Lock } from 'lucide-react';
import usePageTitle from '@/hooks/usePageTitle';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Login({ onLogin }) {
  usePageTitle('Login');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        toast.success('Login realizado com sucesso!');
        onLogin(data.access_token);
        navigate('/dashboard');
      } else {
        toast.error(data.detail || 'Erro ao fazer login');
      }
    } catch (error) {
      toast.error('Erro de conexão com o servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" data-testid="login-page">
      <div className="auth-card fade-in">
        <div className="auth-logo">
          <img src="/coagenda-logo.png" alt="CoAgenda" style={{ width: '180px', height: 'auto', margin: '0 auto 1rem' }} />
          <p>Agenda Colaborativa</p>
        </div>

        <form onSubmit={handleSubmit} data-testid="login-form">
          <div style={{ marginBottom: '1.5rem' }}>
            <Label htmlFor="email">Email</Label>
            <div style={{ position: 'relative', marginTop: '0.5rem' }}>
              <Mail size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
              <Input
                id="email"
                type="email"
                placeholder="seu@email.com"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                data-testid="email-input"
                style={{ paddingLeft: '2.5rem' }}
              />
            </div>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
              <Label htmlFor="password">Senha</Label>
              <Link 
                to="/forgot-password" 
                style={{ 
                  color: '#0ea5e9', 
                  fontSize: '0.85rem', 
                  textDecoration: 'none',
                  fontWeight: 500
                }}
                data-testid="forgot-password-link"
              >
                Esqueci a senha
              </Link>
            </div>
            <div style={{ position: 'relative' }}>
              <Lock size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                data-testid="password-input"
                style={{ paddingLeft: '2.5rem' }}
              />
            </div>
          </div>

          <Button
            type="submit"
            className="w-full"
            disabled={loading}
            data-testid="login-button"
            style={{ marginTop: '1rem' }}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '1.5rem', color: '#64748b', fontSize: '0.9rem' }}>
          Não tem uma conta?{' '}
          <Link to="/register" style={{ color: '#0ea5e9', fontWeight: 600, textDecoration: 'none' }} data-testid="register-link">
            Cadastre-se
          </Link>
        </div>
      </div>
    </div>
  );
}
